document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    // Check if current host is exactly roselli.fi (no subdomain)
    const isMainDomain = window.location.hostname === 'roselli.fi';

    if (!isMainDomain) return;

    fetch('https://ipapi.co/json/')
      .then(res => res.json())
      .then(data => {
        const actualCountry = data.country;

        const euCountries = [
          'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
          'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
          'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
        ];

        if (euCountries.includes(actualCountry) && !sessionStorage.getItem('countryDrawerShown')) {
          const triggerButton = document.querySelector('.custom-markets-selector-trigger');
          const isDrawerOpen = document.querySelector('[data-slideout-id="custom-markets-selector"].open');

          if (triggerButton && !isDrawerOpen) {
            triggerButton.click();
            sessionStorage.setItem('countryDrawerShown', 'true');
          }
        }
      })
      .catch(() => {
        console.warn('GeoIP lookup failed');
      });
  }, 1500);
});
